import React from "react";
import { Box, Typography } from "@mui/material";

const MobileFallback = ({ isPhone }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        minHeight: "100dvh",
        backgroundColor: "#000",
        overflow: "hidden",
      }}
    >
      <iframe
        src="https://player.vimeo.com/video/1158952185?autoplay=1&title=0&byline=0&portrait=0&muted=1&loop=1&background=1&playsinline=1"
        title="10k Science preview"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: "177.78vh",
          height: "100vh",
          minWidth: "100vw",
          minHeight: "56.25vw",
          transform: "translate(-50%, -50%)",
          border: 0,
        }}
        allow="autoplay; fullscreen; picture-in-picture"
        allowFullScreen
      />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          color: "#fff",
          paddingTop: `calc(env(safe-area-inset-top, 0px) + ${
            isPhone ? 12 : 16
          }px)`,
          paddingBottom: isPhone ? "12px" : "16px",
          paddingLeft: isPhone ? "14px" : "20px",
          paddingRight: isPhone ? "14px" : "20px",
          borderRadius: 0,
          width: "100%",
          boxSizing: "border-box",
          overflowWrap: "break-word",
          textAlign: "left",
          boxShadow: "0 12px 28px rgba(0, 0, 0, 0.4)",
          border: "1px solid rgba(255, 255, 255, 0.08)",
        }}
      >
        <Typography variant="h5" sx={{ mb: 1 }}>
          Hi there!
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9 }}>
          Thanks for your interest in the{" "}
          <a
            href="https://10k.science"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: "#7bd0ff",
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            10k Science
          </a>
          {" "}
          Web Viewer. The live viewer is optimized for desktops; mobile support is
          coming soon.
        </Typography>
      </Box>
    </div>
  );
};

export default MobileFallback;
